import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SettingsService } from '../../service/settings.service';
import { Tridys, deepCopy, getKeyValue, getSubtitleKeyOfTridy, getTitleKeyOfTridy, getValueFormatSupport, getValueFromKey, isTimeStamp, returnDateIfStringFormatZ } from 'na-lib';
import { CommentsService } from '../../service/comments.service';
import { QrCodeDialogComponent } from '../../qr-code-dialog/qr-code-dialog.component';
import { environment } from 'src/environments/environment';
import { isDateTime } from 'na-lib';
import { TridyDetailsDialogComponent } from '../tridy-details-dialog/tridy-details-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { extractFilenameFromUrl } from 'na-lib';
import { TridysService } from '../../service/tridys.service';
import { TridyQrExportDialogComponent } from '../tridy-qr-export-dialog/tridy-qr-export-dialog.component';

@Component({
    selector: 'app-tridys-item',
    templateUrl: './tridys-item.component.html',
    styleUrls: ['./tridys-item.component.css'],
    standalone: false
})
export class TridysItemComponent {
  tridyData:any
  routerUrl:any
  idToShow:any
  finishedTasks:any=[]
  payload:any
  tridyValues: Tridys
  contentType:string
  panelOpenState=false
  tridyArray:any
  tridyMap:any
  finishedTasksData:any
  resize:number;
  backToPath:any
  backToPathName:any
  allpayload:any = []
  media:any={}
  mediaData:any
  urlData:any = {}
  outgoing:any[]=[]
  incoming:any[]=[]
  allContentTypesList:any = []
  allTridysList:any
  contentTypeData:any
  payloadCard:any
  showAll:boolean

  titleKey:any
  subtitleKeys:any//string[]

  incomingTitleKey:any
  outgoingTitleKey:any

  titleValue:any
  incomingTitleValue:any
  outgoingTitleValue:any

  subtitleValues:any
  incomingSubtitleValues:any
  outgoingSubtitleValues:any

  fileName:any={}
  constructor(private router: Router,
    private route: ActivatedRoute,
    private settingService: SettingsService,
    public dialog: MatDialog,
    private matDialog: MatDialog,
    private commentService: CommentsService,
    private tridysService: TridysService
  ){
    this.routerUrl = this.route.url;
    const snapshot = this.route.snapshot;
    this.idToShow = snapshot.paramMap.get('tridyId') || snapshot.url.at(-1)?.path;
    this.backToPath = snapshot.parent?.routeConfig?.path?.split('/').at(-1) || 'tridys';
  }

  ngOnInit(): void {
    if (this.settingService.settingsContentTypesWithId.length==0){
      this.settingService.observeContextsContentTypesFirestoreWithId(this.settingService.contextId$).subscribe( ct => this.allContentTypesList = ct)
    }else{
      this.allContentTypesList = this.settingService.settingsContentTypesWithId
    }

    if(this.tridysService.allTridys$.length!=0){
      this.allTridysList = this.tridysService.allTridys$
    }else{
      this.tridysService.observeTridysFirestore().subscribe( results => this.allTridysList = results )
    }

    this.resize = (window.innerWidth <= 760) ? 1 : 2;

    if(this.backToPath=="tridy"){
      this.settingService.allReports$.forEach(element => {
        if(element.id == this.route.snapshot.paramMap.get('reportId')){
          this.backToPathName = element.displayName
        }
      })

    }else{
      this.backToPathName = "Tridys"
    }
   try{
    this.commentService.progressSpin.emit(true)
    this.tridysService.observeTridyIdDoc(this.idToShow).subscribe(tridy => {
      this.tridyData = tridy.data()
      this.tridyData.id = tridy.id

      this.contentTypeData = this.getContentTypeDataById(this.tridyData.contentType)
      this.titleKey = this.getContentTypeFieldById(this.tridyData.contentType, 'titleKey') || false;
      this.subtitleKeys = this.getContentTypeFieldById(this.tridyData.contentType, 'subtitleKeys') || false;

      this.tridysService.getTridyReferences(tridy.id).then(references => {
        this.incoming = references.incoming
        this.outgoing = references.outgoing
      }).catch(error => console.error('Failed to load Tridy references', error))

      this.tridyValues = new Tridys()
      this.tridyValues.setFromAny(this.tridyData)
      this.payload = this.tridyValues.getPayload()

      if(this.payload){
        const foundTitleKey = Object.keys(this.payload).find(key => key == this.titleKey)
        if(foundTitleKey)
          this.titleValue = this.payload[foundTitleKey]

        const foundSubtitleKeys = Array.isArray(this.subtitleKeys) ? this.subtitleKeys : Object.keys(this.payload);
        this.subtitleValues = foundSubtitleKeys.map(key => {
          const value = this.payload[key]
          if(value && (value.seconds || value.nanoseconds)){
            return isDateTime(value)
          }
          else
            return this.payload[key] ? this.payload[key] : key
        });
        if(!this.titleValue)
        this.loadPlaceholdersInKeysTitle()

        this.loadPlaceholdersInKeysSubtitle()

        this.allpayload = Object.entries(this.payload)

        if(this.payload.array)
          this.tridyArray=this.payload.array

        if(this.payload.map)
          this.tridyMap=this.payload.map
      }

      if(this.tridyData && this.tridyData.media){
        this.mediaData = this.tridyData.media
        if(this.payload){
          const payloadKeys = Object.keys(this.payload)
        }

        this.tridyData.media.forEach( med=> {
          this.media[med.key] = med.files
          if(med.files){
            med.files.forEach(async file => {
              await this.supportUrl(file.url, med.key)
              const url = this.urlData[med.key]
              const filename = extractFilenameFromUrl(url)

              if(file.mimeType == "image/jpeg"){
                if(!file.filename)
                  this.fileName[med.key] = filename
                else
                  this.fileName[med.key] = file.filename
              }
            });
          }
        })
      }
      this.contentType = this.tridyValues.contentType
      this.commentService.progressSpin.emit(false)
    })
   }catch(error){
    this.commentService.progressSpin.emit(false)
   }

    this.getFinishedTasks()

  }

  loadPlaceholdersInKeysTitle(){
    if(this.titleKey){
      const placeholders = this.titleKey.match(/\$\{([^}]+)\}/g)?.map(v => v.slice(2, -1));//.matchAll(/\$\{([^}]+)\}/g)
      this.titleValue = deepCopy(this.titleKey)

      if(placeholders){
        placeholders.forEach( key => {
          const valueKey = getKeyValue(this.payload, key)
          const titleValue = deepCopy(this.titleValue)
          let value = valueKey ? getValueFormatSupport(valueKey) : ''
          this.titleValue = titleValue.replaceAll(`\${${key}}`, value)
        })
      }
      const parts = this.titleKey.split(/\s+/);
      if(parts){
        const partsWithDot = parts.filter(k => k.includes(".") && !k?.match(/\$\{([^}]+)\}/g));
        partsWithDot?.forEach(part => {
          const valueKey = getKeyValue(this.payload, part)
          let value = valueKey ? getValueFormatSupport(valueKey) : ''
          this.titleValue = this.titleValue.replaceAll(part, value)
        });
      }
    }

  }

  loadPlaceholdersInKeysSubtitle(){
    this.subtitleValues = deepCopy(this.subtitleKeys)
    if(this.subtitleKeys){
      this.subtitleKeys?.forEach((sub, index) => {
        const placeholdersSub = sub?.match(/\$\{([^}]+)\}/g)?.map(v => v.slice(2, -1));//.matchAll(/\$\{([^}]+)\}/g)
        if(placeholdersSub){
          placeholdersSub.forEach(key => {
            this.subtitleValues.forEach( (subtitle, ind) => {
              const valueKey = getKeyValue(this.payload, key)
              let value = valueKey ? getValueFormatSupport(valueKey) : ''
              this.subtitleValues[ind] = subtitle?.replaceAll('${'+key+'}',value)
            })
          });
        }

        const parts = sub?.split(/\s+/);
        if(parts){
          const partsWithDot = parts.filter(k => k.includes(".") && !k.match(/\$\{([^}]+)\}/g));

          partsWithDot.forEach(part => {
            const valueKey = getKeyValue(this.payload, part)
            let value = valueKey ? getValueFormatSupport(valueKey) : ''
            this.subtitleValues[index] = this.subtitleValues[index]?.replaceAll(part, value)
          });
        }

      });
    }
  }


  getTitleKeyOfTridy(data, titleKey){
    return getTitleKeyOfTridy(data, titleKey)
  }
  getSubtitleKeyOfTridy(data, subtitleKeys){
    return getSubtitleKeyOfTridy(data, subtitleKeys)
  }

    openTridyDetailsDialog(tridyId){

      let dialogRef = this.dialog.open(TridyDetailsDialogComponent, {
        data: {
          idToShow: tridyId,
          allTridysList: this.allTridysList,
          contentTypesList: this.allContentTypesList
        },
        disableClose: true,
        width: '600px',
        panelClass: 'custom-dialog-container',
        position: { right: '0'},
        enterAnimationDuration: '200ms',
        exitAnimationDuration: '200ms'
      });
      dialogRef.afterClosed().subscribe(result => {});
    }

  onResize(event) {
    this.resize = (event.target.innerWidth <= 760) ? 1 : 2;
  }

  backTo(){
    this.route.params.subscribe( (route_:ActivatedRoute) => {
      const contextId = this.settingService.contextId$
      if(route_ && route_['finishedTaskId'] && route_['tridyId'] && !route_['reportId']){
        this.router.navigate(['home', contextId, 'finishedTasks', route_['finishedTaskId'] ])
      }

      if(route_ && route_['tridyId'] && !route_['finishedTaskId'] && !route_['reportId']){
        this.router.navigate(['home', contextId, 'tridys' ])
      }

      if(route_ && route_['tridyId'] && !route_['finishedTaskId'] && route_['reportId']){
        this.router.navigate(['home', contextId, 'reports', route_['reportId']])
      }
    })
  }

  redirectTo(task){
    const contextId = this.settingService.contextId$
    this.route.params.subscribe( (route_:ActivatedRoute) => {
      if(route_ && route_['finishedTaskId'] && route_['tridyId'] && !route_['reportId'])
        this.router.navigate(['home', contextId, 'finishedTasks', task.id ])

      if(route_ && route_['tridyId'] && !route_['finishedTaskId'] && !route_['reportId'])
        this.router.navigate(['home', contextId, 'tridys', this.idToShow, 'finishedTasks', task.id  ])

      if(route_ && route_['tridyId'] && !route_['finishedTaskId'] && route_['reportId'])
        this.router.navigate(['home', contextId, 'reports',  route_['reportId'], 'tridys', this.idToShow, 'finishedTasks', task.id  ])

    })
  }


  getObjectData(payload){
    const values = Object.keys(payload)
    return values
  }

  getFinishedTasks(): void {
    this.settingService.observeTridysIdFinishedTasksFirestore(this.idToShow)
      .then(sortedTasks => {
        this.finishedTasks = sortedTasks;
      })
      .catch(error => {
        console.error('Error fetching tasks:', error);
      });
  }

  isObject(obj){
    return typeof obj === 'object';
  }

  QRoptions(){
    let contentype = this.allContentTypesList?.find( ct => ct.id == this.contentType)
    let nfcPrefix = this.getContentTypeFieldById(this.tridyData.contentType, 'nfcURLPrefix')
    let dialogRef= this.dialog.open(QrCodeDialogComponent, {
      data: {
        tridy:this.tridyData,
        id: this.idToShow,
        nfcPrefix: this.usesAppClip() ? nfcPrefix ?? undefined : undefined,
        name:  contentype?.displayName ?? contentype?.name ?? this.idToShow
      }
    });

  }

  private usesAppClip(): boolean {
    const context = this.settingService.contextAccount$;
    return !String(context?.customDPPHost || '').trim();
  }

  downloadQrZip(): void {
    if (!this.tridyData?.id) return;
    const contentType = this.allContentTypesList?.find(ct => ct.id === this.tridyData.contentType);
    this.matDialog.open(TridyQrExportDialogComponent, {
      width: '760px',
      maxWidth: '96vw',
      data: {
        title: 'Download QR code',
        filenamePrefix: 'dpp-qr-codes',
        contentTypes: contentType ? [contentType] : [],
        tridys: [{
          id: this.tridyData.id,
          payload: this.tridyData.payload || {},
          nfcURLPrefix: contentType?.nfcURLPrefix || this.getContentTypeFieldById(this.tridyData.contentType, 'nfcURLPrefix')
        }]
      }
    });
  }

  showAllPayload(){
    this.showAll = !this.showAll
    if(this.payloadCard){
      this.payloadCard.classList.toggle('d-none', !(this.contentTypeData?.displaySections && this.showAll))
    }
  }
  getPayloadDataByFieldKey(key){
    if(this.allpayload && this.payload){
      const value = getValueFromKey(this.payload, key)
        return isTimeStamp(value) ? value.toDate().toLocaleDateString('de-DE', { year: 'numeric', month: '2-digit', day: '2-digit' }) +
        ', ' + value.toDate().toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' }) : value
    }
  }

  supportUrl(url, key){
    if(url){
      this.urlData[key]=url

     try{
      const imgUrl = new URL(url)
      let hostname = environment.urlHostName
      const isEmulator = environment.useEmulators
      if(imgUrl.protocol=="pass:" ){
        const parts = url.match(/pass:\/\/(.+)\/(.+)/)
        if(parts){
          const passTemplateID = parts[1]
          const path = parts[2]
          let firebaseUrl = `https://${hostname}/v1/pass/${passTemplateID}/${path}`
          if(isEmulator)
          firebaseUrl = `http://localhost:5000/v1/pass/${passTemplateID}/${path}`
          this.urlData[key]=firebaseUrl
        }else{
          const newparts = url.match(/pass:\/\/(.+)/)
          if(newparts){
            let firebaseUrl = `https://${hostname}/v1/pass/${this.idToShow}`
            if(isEmulator)
            firebaseUrl = `http://localhost:5000/v1/pass/${this.idToShow}`
            newparts.forEach( (part,index)=> {
              if(index>0){
                firebaseUrl += '/' + part
              }
            })
            this.urlData=firebaseUrl
          }
        }
      }

      if(imgUrl.protocol =="tridy:"){
        const parts = url.match(/tridy:\/\/(.+)\/(.+)/)
        if(parts){
          let path =""
          parts.forEach((parte, index) =>{
            if(index>0 && index<parts.length){
              path += "/" + parte
            }
          })
          let firebaseUrl = `https://${hostname}/v1/pass${path}`
          if(isEmulator)
            firebaseUrl = `http://localhost:5000/v1/pass${path}`
          this.urlData[key]=firebaseUrl
        }else{
          let path = "/"+this.idToShow
        const partsx = url.match(/tridy:\/\/(.+)/)

        partsx.forEach((parte, index) =>{
          if(index>0 && index<partsx.length){
            path += "/" + parte
          }
        })
        let firebaseUrl = `https://${hostname}/v1/pass${path}`
        if(isEmulator)
          firebaseUrl = `http://localhost:5000/v1/pass${path}`
        this.urlData[key]=firebaseUrl
        }
      }
     }catch(erro){}
    }
  }

  getContentTypeFieldById(id, field){
    const content =  this.allContentTypesList.find( ct => ct.id == id)
    if(content && content[field]){
      return content[field]
    }
  }

  getContentTypeDataById(id){
    const content =  this.allContentTypesList.find( ct => ct.id == id)
    return content
  }


  isDateTime(element){
    return isDateTime(element)
  }

  getTRIDYIdData(tridyId, field){
    if(this.allTridysList){
      const tridy = this.allTridysList.find( id => tridyId == id.id)
      if(tridy && tridy[field]){
        return tridy[field]
      }
    }
  }

  matchingDate(value){
    return returnDateIfStringFormatZ(value)
  }
}